import CurrencyCell from "../components/CurrencyCell";
import { daysInCurrentMonth } from "../helpers";

const currentMonthChannelColDef = [
  {
    headerName: "",
    headerClass: "primary",
    children: [
      { field: "id", hide: true },

      {
        headerClass: "primary",
        field: "Warehouse",
        width: 130,
        enableRowGroup: true,
        enablePivot: true,
        pinned: true,
        editable: true,
        filter: "text",
        hide: false,
      },
      {
        headerClass: "primary",
        headerName: "Channel",
        field: "OutletType",
        width: 120,
        enableRowGroup: true,
        enablePivot: true,
        editable: true,
        pinned: true,
        filter: "text",
        hide: false,
      },
      {
        headerClass: "primary",
        field: "M2",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "M1",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "AOP",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "rightAligned",
      },
      {
        headerClass: "primary",
        field: "M",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        pinned: true,
        type: "valueColumn",
      },
    ],
  },
];

var numberOfDaysInCurrentMonth = daysInCurrentMonth();

for (let day = 1; day <= numberOfDaysInCurrentMonth; day++) {
  currentMonthChannelColDef[0].children.push({
    headerClass: "primary",
    field: String(day), // Dynamic field name
    width: 120,
    enablePivot: true,
    editable: false,
    aggFunc: "sum",
    cellRenderer: CurrencyCell,
    type: "rightAligned",
  });
}

export { currentMonthChannelColDef as currentMonthColDef };
